<template>
<div class="modal" :data-active="active">
  <div class="modal__content">
    <!-- ヘッダー -->
    <div class="modal__header">
      <div v-if="close" @click="closeDialog" class="close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.6004 4.3341L19.6667 2.40039L12.0004 10.0667L4.3341 2.40039L2.40039 4.3341L10.0667 12.0004L2.40039 19.6667L4.3341 21.6004L12.0004 13.9341L19.6667 21.6004L21.6004 19.6667L13.9341 12.0004L21.6004 4.3341Z" />
        </svg>
      </div>
      <slot name="header" v-if="showheader"></slot>
    </div>

    <!-- ボディー -->
    <div class="modal__body">
      <slot name="content"></slot>
    </div>

    <!-- フッター -->
    <div class="modal__footer" v-if="showfooter">
      <slot name="footer"></slot>
    </div>

  </div>

  <div class="modal__backdrop" @click="closeDialog"></div>
</div>
</template>

<script>
export default {
  name: 'app-modal-simple',
  props: {
    active: { type: Boolean, default: false },
    close: { type: Boolean, default: false},
    title: String,
    locationPath: String,
    showheader: { type: Boolean, default: false },
    showfooter: { type: Boolean, default: false },
  },
  methods: {
    closeDialog() {
      gtag('set', 'page_location', this.locationPath);
      this.$emit('close')
    }
  },
  watch: {
    active() {
      document.body.dataset.visibleDialog = this.active
    }
  }
}</script>

<style lang="scss">
body {
  &[data-visible-dialog="false"] { }
  &[data-visible-dialog="true"] { overflow: hidden; }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppModalSimple.vue